import { ThirtyOneError } from '../../Error/ThirtyOneError';
import Logger from '../../Logger/Logger';
import CustomLeaderboardDTO from '../../Models/CustomLeaderboards/CustomLeaderboardDTO';
import { PromiseResponse, PromiseSuccess, PromiseFail } from '../../Models/PromiseResponse';
import CustomLeaderboardApiService from '../CustomLeaderboardApiService';

const logger = Logger.Create('CustomLeaderboardService');

/**
 * Custom Leaderboard service.
 */
export default class CustomLeaderboardService
{
  /**
   * Get.
   * @returns Promise.
   */
  public static async get(): Promise<PromiseResponse<CustomLeaderboardDTO[]>>
  {
    const url = '/Leaderboards';

    return CustomLeaderboardApiService.get<CustomLeaderboardDTO[]>(url)
      .then((response: CustomLeaderboardDTO[]) =>
      {
        logger.info(`Successfully retrieved ${response.length} leaderboard items!`);
        return PromiseSuccess(response);
      })
      .catch((error: ThirtyOneError) =>
      {
        const message = `Error getting the leaderboard items: ${error.message}`;
        logger.error(message);
        return PromiseFail(message);
      });
  }
}
